import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { SiteTemplateComponent } from './shared/containers/site-template/site-template.component';

const routes: Routes = [
  {
    path: ':source',
    component: SiteTemplateComponent,
    children: [
      {
        path: '',
        redirectTo: 'foundation',
        pathMatch: 'full'
      },
      {
        path: 'foundation',
        loadChildren: () => import('./foundation/foundation.module').then(m => m.FoundationModule)
      },
      {
        path: 'mutation',
        loadChildren: () => import('./mutation/mutation.module').then(m => m.MutationModule)
      },
      {
        path: 'domiciliation',
        loadChildren: () => import('./domiciliation/domiciliation.module').then(m => m.DomiciliationModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always'
  } as ExtraOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
